<template>
  <div class="hello">
    <div v-if="this.competitions.length > 0">
      <h4>Die nächsten Wettbewerbe:</h4>
      <div v-for="competition in competitions" class="mt-4">
        <h5>{{ competition.title() }}</h5>
        <competition-dates :competition="competition" :header-class="headerClass"></competition-dates>
      </div>

    </div>
  </div>
</template>

<script>
import {Competition} from '@/models'
import CompetitionDates from '@/components/competitions/DatesTable'
export default {
  name: 'Welcome',
  components: {
    'competitionDates': CompetitionDates
  },
  data () {
    return {
      competitions: [],
      headerClass: ['pr-5', 'font-weight-bold']
    }
  },
  mounted () {
    this.axios.get('/competitions/public')
      .then((rsp) => {
        rsp.data.forEach((data) => {
          let competition = new Competition()
          competition.parse(data)

          this.competitions.unshift(competition)
          this.next = competition
        })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/guests/Welcome.vue